import {Header as DeereHeader} from '@deere/ux.uxframe-react';
import UserDropdown from './UserDropdown';
import React from 'react';
import {TopNav} from './TopNav';
import {useUserInfo} from '../providers/userProvider'

function searchJDSN(e) {
    const searchText = e.target.uxfsearchinput.value;

    window.open(
        `https://jdsn.deere.com/wps/myportal/jdsn/Home/SupplierSearch?sources=${
            escape(searchText)}`,
        'JDSN Search'
    );
    e.preventDefault();
}

export default function Header() {
    const Dropdown = <UserDropdown/>;
    const userInfo = useUserInfo();
    return (
        <DeereHeader
            clearBtnProps={{
                ariaLabel: 'Clear search'
            }}
            formProps={{
                onSubmit: searchJDSN
            }}
            headerTitleComponent={Dropdown}
            inputProps={{
                ariaLabel: 'Search',
                name: 'uxfsearchinput'
            }}
            logoLink='http://deere.com'
            pageHeading='Supply Network'
            pageHeadingLink='http://jdsn.deere.com'
            skipLink='#content'
            submitBtnProps={{
                ariaLabel: 'Search'
            }}
        >
        <TopNav
            userId={userInfo && userInfo.hasOwnProperty("userID") && typeof userInfo.userID === "string" && userInfo.userID.trim().length > 0 ? userInfo.userID : ""}
            userRoles={userInfo && userInfo.hasOwnProperty("roles") && Array.isArray(userInfo.roles) ? userInfo.roles : []}
        />
        </DeereHeader>
    );
}